import React from 'react'
import { redirect } from 'react-router-dom'
import {
  Index,
  JobAd,
  JobAdDetails,
  JobAdApply,
  JobAdQuickInterview,
  JobAdThankYou,
  JobAdSeeYou,
  ContinueApplication,
} from 'careers/pages'
import CareersApp from 'careers/app'
import Error404 from 'components/errors/404'
import { parse as qs } from 'qs'

export default onEnter => ([
  {
    path: '/careers/linked-in/callback',
    loader: ({ request }) => {
      const url = new URL(request.url)
      let search = url.search
      if (search[0] === '?') {
        search = search.substring(1)
      }
      const query = qs(search)
      const lang = window.sessionStorage.getItem('careersLang')
      const companyId = window.sessionStorage.getItem('careersCompany')
      const jobAdId = window.sessionStorage.getItem('careersJobAd')
      const csrfToken = window.sessionStorage.getItem('careersCsrf')

      window.sessionStorage.removeItem('careersLang')
      window.sessionStorage.removeItem('careersCompany')
      window.sessionStorage.removeItem('careersJobAd')
      window.sessionStorage.removeItem('careersCsrf')

      const { error, code } = query
      const returnedCsrfToken = query.state

      if (
        csrfToken !== returnedCsrfToken
        || !lang
        || !companyId
        || !jobAdId
      ) {
        return redirect('/403')
      } else if (error) {
        return redirect(`/careers/${lang}/${companyId}/${jobAdId}/apply?linkedInError=${error}`)
      } else {
        return redirect(`/careers/${lang}/${companyId}/${jobAdId}/apply?linkedInCode=${code}`)
      }
    },
  },
  {
    path: '/careers/:language',
    element: <CareersApp />,
    loader: onEnter,
    children: [
      {
        path: '',
        element: <Error404 />,
      },
      {
        path: ':companySlug',
        element: <Index />,
      },
      {
        path: ':companySlug/:adSlug',
        element: <JobAd />,
        children: [
          {
            path: '',
            element: <JobAdDetails />,
          },
          {
            path: 'apply',
            element: <JobAdApply />,
          },
          {
            path: 'interview',
            element: <JobAdQuickInterview />,
          },
          {
            path: 'thankyou',
            element: <JobAdThankYou />,
          },
          {
            path: 'seeyou',
            element: <JobAdSeeYou />,
          },
          {
            path: 'application/:token',
            element: <ContinueApplication />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Error404 />,
  },
])
